import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";

export const CUSTOMER_SAP_EXPORT_ERROR_CATEGORIES_RESOURCE = "customer-sap-export" as const;
export const CUSTOMER_SAP_EXPORT_ERROR_CATEGORIES_OPERATION = "error-categories" as const;
export const CUSTOMER_SAP_EXPORT_ERROR_CATEGORIES_API_PATH =
  `/v1/${CUSTOMER_SAP_EXPORT_ERROR_CATEGORIES_RESOURCE}/${CUSTOMER_SAP_EXPORT_ERROR_CATEGORIES_OPERATION}` as const;

export type CustomerSapExportErrorCategoriesResponse =
  paths[typeof CUSTOMER_SAP_EXPORT_ERROR_CATEGORIES_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useCustomerSapExportErrorCategoriesQuery() {
  return useQuery({
    queryKey: [CUSTOMER_SAP_EXPORT_ERROR_CATEGORIES_RESOURCE, CUSTOMER_SAP_EXPORT_ERROR_CATEGORIES_OPERATION],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<CustomerSapExportErrorCategoriesResponse>(
        CUSTOMER_SAP_EXPORT_ERROR_CATEGORIES_API_PATH,
      );

      return response.data;
    },
  });
}
